var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StudioTemplate',{attrs:{"bannerSrc":"/assets/image/about-studio/studio_banner.jpg","pageTitle":_vm.$t('label.creativeCookingSpace'),"pageSubtitle":_vm.$t('label.spaceToEmbraceCreativeContent'),"isPDF":true,"topic":"faqs"}})
}
var staticRenderFns = []

export { render, staticRenderFns }